import { number } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { getAlphasCount } from './commons.js';
const MIN_ALPHAS = 'min-alphas';
function MinAlphasValidator(value, { min = Number.MIN_SAFE_INTEGER } = {}) {
    const current = value === undefined || value === null ? 0 : getAlphasCount(value);
    const valid = current >= min;
    return [{
            message: current === 0
                ? MessageService.translate('tws.validator.min-alphas-must-contain')
                : MessageService.translate('tws.validator.min-alphas-unmet', { min }),
            name: MIN_ALPHAS,
            valid,
        }];
}
MinAlphasValidator.optionTypes = {
    min: number,
};
export { MIN_ALPHAS, MinAlphasValidator, };
export default MinAlphasValidator;
//# sourceMappingURL=min-alphas.js.map